import { render, staticRenderFns } from "./GoToStartButton.vue?vue&type=template&id=7f874f4f&scoped=true&lang=pug&"
import script from "./GoToStartButton.vue?vue&type=script&lang=js&"
export * from "./GoToStartButton.vue?vue&type=script&lang=js&"
import style0 from "./GoToStartButton.vue?vue&type=style&index=0&id=7f874f4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f874f4f",
  null
  
)

export default component.exports